export default "__VITE_PUBLIC_ASSET__97f23f0d__"